import lscache from "lscache";

import {PROPERTY_CONFIGURATOR_VALUES} from "../../app/constants/storage_keys";
import {searchFormFields} from "../reducers/property_configurator_reducer";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SearchFormValuesType = Record<keyof typeof searchFormFields, any> & {instalment?: number};

export function setPropertyConfiguratorStorageData(values: SearchFormValuesType) {
    const filteredOutUtmParams = filterUtmFromParams(values);

    lscache.set(PROPERTY_CONFIGURATOR_VALUES, {
        ...filteredOutUtmParams
    });
}

export function getPropertyConfiguratorStorageData(): SearchFormValuesType {
    const values = lscache.get(PROPERTY_CONFIGURATOR_VALUES);
    if (values) {
        return filterUtmFromParams(values) || {};
    }
    return {} as SearchFormValuesType;
}

const filterUtmFromParams = (values: SearchFormValuesType) => {
    const valuesKeyArray = Object.keys(values) as (keyof typeof searchFormFields)[];

    return valuesKeyArray.reduce((acc, key) => {
        if (key.includes("utm_")) {
            return acc;
        }

        return {...acc, [key]: values[key]};
    }, {} as SearchFormValuesType);
};
import lscache from "lscache";

import {PROPERTY_CONFIGURATOR_VALUES} from "../../app/constants/storage_keys";
import {searchFormFields} from "../reducers/property_configurator_reducer";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SearchFormValuesType = Record<keyof typeof searchFormFields, any> & {instalment?: number};

export function setPropertyConfiguratorStorageData(values: SearchFormValuesType) {
    const filteredOutUtmParams = filterUtmFromParams(values);

    lscache.set(PROPERTY_CONFIGURATOR_VALUES, {
        ...filteredOutUtmParams
    });
}

export function getPropertyConfiguratorStorageData(): SearchFormValuesType {
    const values = lscache.get(PROPERTY_CONFIGURATOR_VALUES);
    if (values) {
        return filterUtmFromParams(values) || {};
    }
    return {} as SearchFormValuesType;
}

const filterUtmFromParams = (values: SearchFormValuesType) => {
    const valuesKeyArray = Object.keys(values) as (keyof typeof searchFormFields)[];

    return valuesKeyArray.reduce((acc, key) => {
        if (key.includes("utm_")) {
            return acc;
        }

        return {...acc, [key]: values[key]};
    }, {} as SearchFormValuesType);
};
